module.exports = __webpack_public_path__ + "static/media/arrow-right.a5cfe992.svg";